"use client";

import { useEffect, useRef } from "react";
import Userback from "@userback/widget";
import { useAuth } from "@/features/auth";

export function UserbackProvider() {
  const { user, isAuthenticated } = useAuth();
  const initializedRef = useRef(false);

  useEffect(() => {
    const token = process.env.NEXT_PUBLIC_USERBACK_TOKEN;
    if (!token || !isAuthenticated || !user || initializedRef.current) return;

    initializedRef.current = true;

    Userback(token, {
      user_data: {
        id: user.id,
        info: {
          name: user.full_name,
          email: user.email,
        },
      },
    });
  }, [isAuthenticated, user]);

  return null;
}
